import styled from 'styled-components';
import { Box, FormHelperText } from '@mui/material';

export const TitlesWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  marginBottom: '24px',
  maxWidth: '600px',
});

export const StyledFormHelperText = styled(FormHelperText)({
  color: 'red',
  fontSize: '14px',
  marginTop: '8px',
});

export const ImagePreviewBox = styled(Box)({
  position: 'relative',
  width: '120px',
  height: '120px',
  borderRadius: '8px',
  overflow: 'hidden',
  border: '1px solid #ccc',
  img: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
});
